<template>
    <div class='container'>

        <tips style="padding-top:14px;">体验间点检</tips>
        <div class="screen">
            <div class="screen1">筛选</div>
            <div class="sendDownBox">
                <span v-if="Bckscreen">折叠</span>
                <span v-else>展开</span>
                <img class="sendDownImg" @click="Bckscreen = !Bckscreen" :class="[Bckscreen?'rotate':'rotate2']" src="@/assets/images/user/talk/send_down_icon.png" alt="">
            </div>
        </div>
        <transition name="fade-transition" mode="out-in">
            <div v-if="Bckscreen" style="padding: 0 12px;">
                <!-- 代理商选择 -->
                <div class="agent">
                    <div class="left flc2">
                        <div class="flc3">代理商</div>
                        <div class="flc"></div>
                    </div>
                    <div class="right">
                        <div class="select-item flc" @click="selectType2('area')">
                            {{ options.area || '大区' }}
                            <img src="@/assets/images/user/talk/select.png" alt="">
                        </div>
                        <div class="select-item flc" @click="selectType2('city')">
                            {{ options.city || '城市' }}
                            <img src="@/assets/images/user/talk/select.png" alt="">
                        </div>
                        <div class="select-item flc" @click="selectType2('platform')">
                            {{ options.platform || '请选择代理商'}}
                            <img src="@/assets/images/user/talk/select.png" alt="">
                        </div>
                    </div>
                </div>
                <!-- 负责人 -->
                <div class="info flc2">
                    <div class="left flc3">
                        负责人
                    </div>
                    <div class="right flc">
                        <input type="text" placeholder="请输入负责人姓名" v-model="options.chargePeople">
                    </div>
                </div>
                <!-- 体验间 -->
                <div class="info flc2">
                    <div class="left flc3">
                        体验间
                    </div>
                    <div class="right flc">
                        <input type="text" placeholder="请输入体验间" v-model="options.templateName">
                    </div>
                </div>
                <!-- 状态 -->
                <div class="info">
                    <div class="left">
                        <div class="flc3">
                            状态
                        </div>
                        <div></div>
                    </div>
                    <div class="right">
                        <div @click="statusClick(item.id)" class="status-item flc" :class="{'active_item':options.currentStatus == item.id}" v-for="(item,index) in statusList" :key="index">{{item.name}}</div>
                    </div>
                </div>
                <!-- 时间 -->
                <div class="info flc2">
                    <div class="left ">
                        时间
                    </div>
                    <div class="right">
                        <div class="time">
                            <div class="flc" @click="chooseStart">{{options.startTime}}</div>
                            <div class="flc">至</div>
                            <div class="flc" @click="chooseEnd">{{options.endTime}}</div>
                        </div>
                    </div>
                </div>
                <!-- 清空 -->
                <div class="btn flc" @click="clearOptions">清空</div>
                <!-- 分割线 -->
                <div class="border-line">
                    <img src="@/assets/images/user/talk/border-bottom.png" alt="">
                </div>
            </div>
        </transition>
        <!-- 点检列表 -->
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getbottom"
                :immediate-check="false" :offset="10"
                >
            <div class="content_box">
                <div class="title">点检记录列表（{{timeRange}}）</div>
                <div class="content" v-if="CheckList.length != 0">
                    <div class="time_item" v-for="(item,index) in CheckList" :key="index">
                        <!-- 时间 -->
                        <div class="time">{{item.time}}</div>
                        <div class="template_info" v-for="(item2,index2) in item.children" :key="index2">
                            <div class="box">
                                <div class="info1" @click="goTimeList(item2.experience_id)">
                                    <div>{{item2.project_name}}({{item2.area_name}})</div>
                                    <div>负责人:{{item2.group_name}}</div>
                                </div>
                                <div class="info2" >
                                    <div @click="checkSpin(item2.id,item2.myState,item2.experience_id,item2.is_sign)" v-if="item2.myState == 0" class="status1 flc">{{item2.myTips}}</div>
                                    <div @click="fillCheckInfo(item2.id,item2.created_date)" v-else-if="item2.myState == 1" class="status3 flc">{{item2.myTips}}</div>
                                    <div @click="checkSpin(item2.id,item2.myState,item2.experience_id,item2.is_sign)" v-else-if="item2.myState == 2" class="status0 flc">{{item2.myTips}}</div>
                                    <div @click="checkSpin(item2.id,item2.myState,item2.experience_id,item2.is_sign)" v-else-if="item2.myState == 3" class="status2 flc">{{item2.myTips}}</div>
                                    <div @click="lookCheckInfo(item2.reason)" v-else-if="item2.myState == 4" class="status3 flc">{{item2.myTips}}</div>
                                    <div v-else-if="item2.myState == 5" class="status3 flc">{{item2.myTips}}</div>
                                </div>
                            </div>
                            <!-- 分割线 -->
                            <div class="border-line">
                                <img src="@/assets/images/user/talk/border-bottom.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>

        <!-- 时间选择 -->
        <van-popup v-model="BchooseTime" position="bottom">
            <van-datetime-picker @confirm="selectTime" type="date" @cancel="BchooseTime = false" title="选择年月日" :min-date="minData" :max-date="maxData" v-model="currentDate"/>
        </van-popup>

        <!-- 大区 城市 代理商选择 -->
        <van-popup  v-model="BselectPopup" round position="bottom">
            <van-picker ref="choose"  show-toolbar @confirm='confirmPopup' @cancel='cancelPopup' title="请选择" :columns="columns" />
        </van-popup>


        <!-- 查看不点检原因或者填写不点检原因 -->
        <van-popup class="date-pop" v-model="noCheck">
            <div class="pop-wrap">
                <div class="pop-title">
                    {{noCheckLook?'未点检原因':'请填写未点检原因'}}
                </div>
                <div class="tips" v-if="!noCheckLook">如无法点检，请14天内提交未点检原因</div>
                <div class="texttare-class">
                    <textarea :disabled="noCheckLook" v-model="noCheckInfo" placeholder="请输入未点检原因"  class="text-style" name="" id="" cols="30" rows="8"></textarea>
                </div>
                <div class="pop-btn-wrap" v-if="!noCheckLook">
                    <div class="pop-btn" @click="noCheck = false">取消</div>
                    <div class="pop-btn" @click="sendNoCheck">提交</div>
                </div>
                <div class="pop-btn-wrap" v-else>
                    <div class="pop-btn" @click="noCheck = false">返回</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
import tips from '@/components/tips/index'
export default {
    name:'check',
    components:{
        tips,
    },
    data(){
        return {
            noCheck:false,//显示不点检原因弹窗
            noCheckLook:true,//查看不点检原因还是填写不点检原因 true 为查看 false 为填写
            noCheckInfo:'',//不点检原因
            finished:false,
            loading:false,
            Bfirst:false,//是否第一次进入
            // 筛选数据开始
            optionCount:{
                page:0,
                limit:20,
            },
            options:{
                chargePeople:'',//负责人
                templateName:'',//体验间
                startTime:'',//开始时间
                endTime:'',//结束时间
                currentStatus:-1,//当前选中的状态
                platform:'',//选择的代理商
                city:'',//选择的城市
                area:'',//选择的大区
            },
            // 筛选数据结束
            selectType:'',// area 大区 city 城市 platform 代理商
            Bckscreen:false,//筛选显示或者隐藏
            columns:[],//picker使用的数组
            BselectPopup:false,//谈弹窗显示
            BchooseStatus:'',//end 结束时间 start 开始时间
            BchooseTime:false,//显示选择时间弹窗
            minData:new Date(2012,0,1),     //最小的时间，因为选择开始时间后不能选择比他还小的时间，
            maxData:new Date(2032,11,31),   //最大时间，因为如果选择了结束时间后不能选择比他还大的时间
            // 点检状态 0待点检 1未点检 2问题事项 3已点检，-1全部
            statusList:[
                {name:'问题事项',id:2},
                {name:'待点检',id:0},
                {name:'未点检',id:1},
                {name:'已点检',id:3},
                {name:'全部',id:-1},
            ],
            currentDate:'',// 默认选中时间
            noCheckId:'',//不点检的id
        }
    },
    computed : {
        // 查看是返回 未点检 还是 不点检原因 ，14天内，显示不点检原因 如果超过了14天就显示未点检
        showInfo (time) {
            return (time) => {
                let date = Date.parse(new Date()) - 14*24*60*60*1000
                date = new Date(date)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                month = month <10 ?'0' + month :month
                day = day <10 ?'0' + day :day
                let nowDate = `${year}-${month}-${day}`
                return time > nowDate?'未点检反馈':'无故未点检'
            }
        },
        timeRange () {
            console.log(this.options.startTime,this.options.endTime,'this.options.endTime');
            if (this.options.startTime == '' || this.options.endTime == '') {
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                month = month < 10 ?'0' + month :month
                day = day < 10 ?'0' + day :day
                let nowDate = `${year}-${month}-${day}`
                // 获取30天前的时间搓
                const pastTime = Date.parse(new Date())- 30 *24 *60 *60* 1000
                let pastDate = new Date(pastTime);
                let pastyear = pastDate.getFullYear()
                let pastmonth = pastDate.getMonth() + 1
                let pastday = pastDate.getDate()
                pastmonth = pastmonth < 10 ?'0' + pastmonth :pastmonth
                pastday = pastday < 10 ?'0' + pastday :pastday
                let pastDate2 = `${pastyear}-${pastmonth}-${pastday}`
                return `${pastDate2}~${nowDate}`
            } else {
                return `${this.options.startTime}~${this.options.endTime}`
            }
        },
        SelectColumn (type) {
            let _that = this
            return type => {
                let column = _that.$store.state.userTalkAppointV3.SelectColumn[type]
                if (column.length == 0) {
                    return ['全部']
                } else {
                    return column
                }
            }
        },
        CheckList () {
            let _that = this
            return _that.$store.state.userTalkAppointV3.CheckList
        }
    },
    watch :{
        options:{
            handler(newObj,oldObj) {
                this.finished = false
                this.optionCount = {
                    page:0,
                    limit:20
                }
                this.getCheckList()
            },
            deep:true,
        }
    },
    created () {
        let _that = this
        let date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        this.currentDate = new Date(year, month,day)
        // fetchVerifyAuthForB (() => {
            _that.$store.dispatch({type:'userTalkAppointV3/getProjectpre'})
            _that.getCheckList1()
        // })
    },
    mounted() {
    },
    beforeRouteEnter (to,from,next) {
        next((vm) => {
            // 如果用户是直接进入的点检，那么要让父路由选中也是点检，，但是默认它是选中体验预约，所以需要添加一个路由守卫
            vm.$emit('check')
            vm.optionCount = {
                page:0,limit:20
            }
        })
    },
    methods :{
        // 确定提交不点检
        sendNoCheck () {
            let _that = this
            if (!_that.noCheckInfo.trim()) {
                _that.$toast('未点检原因不得为空')
                return
            }
            _that.$store.dispatch({type:'userTalkAppointV3/ProjectUncheck',check_id:_that.noCheckId,reason:_that.noCheckInfo}).then( () => {
                _that.$toast("提交成功")
                _that.noCheck = false
                _that.$set(this.optionCount,'page',0)
                _that.getCheckList1()
            })
        },
        // 点击未点检，填写点检信息
        fillCheckInfo (id,time) {
            console.log(time);
            // let info = this.showInfo(time)
            // if (info == '无故未点检') {
            //     return
            // }
            this.noCheckLook = false
            this.noCheck = true
            this.noCheckInfo = ''
            this.noCheckId = id
        },
        // 点击不点检，查看点检信息
        lookCheckInfo (info) {
            this.noCheckInfo = info
            this.noCheck = true
            this.noCheckLook = true
        },
        // 获取点检列表 (首次)
        getCheckList1 () {
            this.$store.dispatch({type:'userTalkAppointV3/getCheckList',search_state:-1, search_start:this.timeRange.split('~')[0],search_end:this.timeRange.split('~')[1],...this.optionCount})
        },
        // 获取体验间点检列表(搜索)
        getCheckList () {
            let _that = this
            let options = {
                search_area:_that.options.area,//搜索城市
                search_city:_that.options.city,//搜索大区
                search_platform:_that.options.platform,//搜索代理商
                search_sign:_that.options.chargePeople,//搜索主要负责人手机或者姓名
                search_project:_that.options.templateName,//搜索体验间
                search_state:_that.options.currentStatus.toString() || -1,//点检状态 0待点检 1未点检 2问题事项 3已点检，-1全部
                search_start:_that.options.startTime || _that.timeRange.split('~')[0],//搜索开始时间
                search_end:_that.options.endTime || _that.timeRange.split('~')[1],//搜索结束时间
            }
            _that.$store.dispatch({type:'userTalkAppointV3/getCheckList',...options,..._that.optionCount}). then (() => {
                _that.loading = false
            })
        },
        goTimeList (project_id) {
            console.log(project_id,'project_id');
            this.$router.push(`/hvac/talk/cktime?project_id=${project_id}`)
        },
        // 触底
        getbottom () {
            this.loading = true
            this.optionCount.page += 1
            let oldStr = this.CheckList.toString();
            let options = {
                search_area:this.options.city,//搜索城市
                search_city:this.options.area,//搜索大区
                search_platform:this.options.platform,//搜索代理商
                search_sign:this.options.chargePeople,//搜索主要负责人手机或者姓名
                search_project:this.options.templateName,//搜索体验间
                search_state:this.options.currentStatus.toString() || -1,//点检状态 0待点检 1未点检 2问题事项 3已点检，-1全部
                search_start:this.options.startTime  || this.timeRange.split('~')[0],//搜索开始时间
                search_end:this.options.endTime || this.timeRange.split('~')[1],//搜索结束时间
            }
            this.$store.dispatch({type:'userTalkAppointV3/getCheckList2',...options,...this.optionCount}) .then (() =>{
                if (oldStr == this.CheckList.toString()) {
                    this.finished = true
                    // this.$toast('我也是有底线的')
                }
                this.loading = false
            })
        },
        // 点击不合格等触发的函数
        checkSpin (id,state,id2,sign) {
            // 点检状态 0待点检 1未点检 2问题事项  3已点检
            // 问题事项、已点检：查看点检记录  待点检：点击就是填写点检记录（默认永远在最上面）
            // 未点检：单纯状态无法点击（不可补）
           console.log('平台管理:2' + this.$store.state.userTalkAppointV3.BIdentity);

            if (state == 1) {
                console.log(state,'state');
                return
            } else if (state == 2 ||state == 3) {
                // type 1 查看.type 2 填写
                // id:点检id
                // id2:体验间id
                this.$router.push(`/hvac/talk/v3/ckdetail?type=1&id=${id}&id2=${id2}`)
            } else if(state == 0) {
                // 如果是负责人可以点检,可以查看
                // 如果是管理员,那么就只能查看,不能点检
                // 如果又是负责人又是管理员可以点检
                if (sign == 1) {
                    // const date = new Date()
                    // let week = date.getDay()
                    // console.log(week,'week');
                    // // 判断今天 周几,如果是一三五可以点检,如果是其他的,不可以点检
                    // if ( week %2 == 0) {
                    //     this.$toast('只有周一,周三,周五能进行点检')
                    //     return
                    // }
                    this.$router.push(`/hvac/talk/v3/ckdetail?type=2&id=${id}&id2=${id2}`)
                } else {
                    console.log(sign,'sign');
                    this.$toast("抱歉,您无法点检")
                    return
                }
            }
        },
        // 清空筛选的数据
        clearOptions () {
            this.options = {
                chargePeople:'',//负责人
                templateName:'',//体验间
                startTime:'',//开始时间
                endTime:'',//结束时间
                currentStatus:-1,//当前选中的状态
                platform:'',//选择的代理商
                city:'',//选择的城市
                area:'',//选择的大区
            }
        },
        // 取消选择
        cancelPopup () {
            this.BselectPopup = false
        },
        // 确定选择
        confirmPopup (selected) {
            if (this.selectType == 'area' ) {
                this.$set(this.options,'area',selected)
            } else if (this.selectType == 'city' ) {
                this.$set(this.options,'city',selected)
            } else if (this.selectType == 'platform' ) {
                this.$set(this.options,'platform',selected)
            }
            this.BselectPopup = false
        },
        // 大区地区代理商选择
        selectType2 (type) {
            this.BselectPopup = true
            this.selectType = type
            console.log(this.SelectColumn(type),'this.SelectColumn(type)');
            this.columns = this.SelectColumn(type)
        },
        // 状态选择
        statusClick (id) {
            if (this.options.currentStatus == id) {
                this.$set(this.options,'currentStatus',null)
            } else {
                this.$set(this.options,'currentStatus',id)
            }
        },
        // 结束时间选择
        chooseEnd () {
            this.BchooseTime = true
            this.BchooseStatus = 'end'
            this.maxData = new Date(2032,11,31)
        },
        // 开始时间选择
        chooseStart () {
            this.BchooseTime = true
            this.BchooseStatus = 'start'
            this.minData = new Date(2012,0,1)
        },
        // 选择时间
        selectTime (e) {
            this.BchooseTime = false;
            var time  = new Date(e);
            const year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            month = (month < 10) ? '0' + month : month
            day = (day < 10) ? '0' + day : day
            if (this.BchooseStatus == 'start') {
                this.$set(this.options,'startTime',year + '-' + month + '-' + day)
                this.minData = new Date(year,month - 1,day)
            } else {
                this.$set(this.options,'endTime', year + '-' + month + '-' + day)
                this.maxData = new Date(year,month,day)
            }
        },
    }
}
</script>
<style lang='scss' scoped>
::v-deep .van-popup {
    z-index: 99 !important;
}
::v-deep .van-overlay {
    z-index: 98 !important;
}
.date-pop {
    width: 76%;
    top: 40.5%;
    border-radius: 16px;
    .pop-wrap {
        height: 490px;
        background: #FFFFFF;
        border-radius: 16px;
        overflow: hidden;

        .pop-title {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
            line-height: 44px;
            text-align: center;
            margin-top: 40px;
        }
        .tips {
            text-align: center;
            font-size: 20px;
            color: #818c96;
        }
        .texttare-class {
            margin-top: 20px;
            padding: 0 40px;
            .text-style {
                padding: 20px;
                box-sizing: border-box;
                height: 220px;
                width: 100%;
                border-radius: 16px;
                background: #f7f7f7;
                resize: none;
            }
        }

        .pop-content {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #318544;
            line-height: 40px;
            text-align: center;
            margin-top: 60px;

        }


          .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-top: 24px;

            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
    }
}
.container {
    width:684px;
    margin:0 auto;
    background: #FFFFFF;
    border-radius: 16px;
    margin-bottom:120px;
    position: relative;


    .screen {
        padding:20px 24px 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .screen1 {
            font-size: 26px;
            font-weight: 600;
        }
        .sendDownBox {
            display: flex;
            align-items: center;
            .sendDownImg {
                margin-left: 10px;
                width: 32px;
                height: 29px;
            }
        }
    }
    .agent {
        margin-top: 20px;
        width: 100%;
        display: flex;
        .left {
            width: 84px;
            display: flex;
            flex-direction: column;
            font-size: 28px;
            font-weight: 400;
            color: #444444;
            div {
                margin-bottom: 10px;
                flex: 1;
                white-space: nowrap;
            }
        }
        .right {
            margin-left: 48px;
            display: flex;
            flex-wrap: wrap;
            .select-item{
                width: 244px;
                border-radius: 12px;
                border: 2px solid #DBDBDB;
                position: relative;
                padding: 20px 0;
                font-size: 28px;
                font-weight: 400;
                color: #444444;
                &:nth-child(1)  {
                    margin-right: 20px;
                }
                &:nth-child(3) {
                    margin-top: 20px;
                    width: 508px;
                    border-radius: 12px;
                    border: 2px solid #DBDBDB;
                }
                img {
                    width: 32px;
                    height: 32px;
                    position: absolute;
                    color: #444444;
                    right: 16px;
                }
            }
        }
    }
    .info {
        margin-top: 28px;
        width: 100%;
        display: flex;
        .left {
            width: 84px;
            font-size: 28px;
            font-weight: 400;
            color: #444444;
            white-space: nowrap;
            display: flex;
            flex-direction: column;
            div{
                flex: 1;
                margin-bottom: 10px;
            }
        }
        .right {
            flex: 1;
            margin-left: 48px;
            font-size: 28px;
            font-weight: 400;
            color: #A2A2A2;
            display: flex;
            flex-wrap: wrap;

            .time {
                width: 100%;
                height: 80px;
                background: #F7F7F7;
                border-radius: 12px;
                display:flex;
                align-items:center;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #A2A2A2;
                div:nth-child(1) {
                    height:100%;
                    color: #444444;
                    flex: 1;
                }
                div:nth-child(3) {
                    height:100%;
                    color: #444444;
                    flex: 1;
                }
                div:nth-child(2) {
                    width: 28px;
                }
            }
            input {
                width: 100%;
                padding: 20px 0;
                background: transparent;
                text-align: center;
                width: 508px;
                background: #F7F7F7;
                border-radius: 12px;
                color: #444444;
            }
            .status-item {
                width: 158px;
                height: 80px;
                background: #F7F7F7;
                border-radius: 12px;
                margin-right: 15px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:nth-child(n+4) {
                    margin-top: 20px;
                }
            }
            .active_item {
                font-size: 28px;
                font-weight: 500;
                color: #318544;
                background: rgba(49, 133, 68, 0.1);
                border-radius: 12px;
            }
        }
    }
    .btn {
        width: 300px;
        height: 80px;
        background: #318544;
        border-radius: 8px;
        margin: 36px auto 36px;
        font-size: 28px;
        font-weight: 400;
        color: #FFFFFF;
    }
    .border-line {
        width: 636px;
        height: 4px;
        margin: 0 auto 0;
        img {
            width: 636px;
            height: 4px;
        }
    }
    .content_box {
        padding:0 24px 20px;
        width: 100%;
        .title {
            margin-top: 30px;
            font-size: 28px;
            font-weight: 500;
            color: #313131;
            margin-bottom: 18px;
        }
        .content {
            .time_item {
                .time {
                    margin-top: 28px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #262626;
                }
                .template_info {
                    .box {
                        width: 100%;
                        padding-left: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .info1 {
                            padding: 24px 0;
                            flex: 1;
                            font-size: 24px;
                            font-weight: 400;
                            color: #575757;
                            div:nth-child(2){
                                margin-top: 8px;
                            }
                        }
                        .info2 {
                            div {
                                width: 186px;
                                height: 68px;
                                font-weight: 400;
                                font-size: 24px;
                                border-radius: 8px;
                            }
                            .status0 {
                                background: #E9A355;
                                color: #FFFFFF;
                            }
                            .status1 {
                                color: #FFFFFF;
                                background: #4F9E61;
                            }
                            .status2 {
                                color: #777777;
                                background: #E9E9E9;
                            }
                            .status3 {
                                color: #CE4C4C;
                                background: #E9E9E9;
                            }
                        }
                    }
                }
            }
        }
    }

    .border-line {
        width: 636px;
        height: 4px;
        margin: 0 auto 0;
        img {
            width: 636px;
            height: 4px;
        }
    }
}

.fade-transition-enter-active,
.fade-transition-leave-active{
    transition: all 0.3s;
}
.fade-transition-enter {
    opacity: 0;
    transform: translateY(30px);
}
.fade-transition-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
.rotate {
    transform: rotate(180deg);
    transition: all 0.3s;
}
.rotate2 {
    transform: rotate(0deg);
    transition: all 0.3s;
}
.flc{
    display:flex;
    justify-content:center;
    align-items:center;
}

.flc2 {
    display: flex;
    align-items: center;
}
.flc3 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.positionc{
    left:50%;
    transform:translate(-50%);
}
</style>
